var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var StyledShowMoreButton = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: underline;\n  white-space: nowrap;\n  &:hover{\n    cursor: pointer;\n  }\n"], ["\n  text-decoration: underline;\n  white-space: nowrap;\n  &:hover{\n    cursor: pointer;\n  }\n"])));
var ShowMoreButton = function (_a) {
    var open = _a.open, openText = _a.openText, closeText = _a.closeText, toggleOpen = _a.toggleOpen, className = _a.className;
    return _jsx(StyledShowMoreButton, __assign({ className: className, onClick: function () { return toggleOpen && toggleOpen(); } }, { children: open ? openText : closeText }));
};
export default ShowMoreButton;
var templateObject_1;
